'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'right-to-bracket';
var width = 512;
var height = 512;
var aliases = ["sign-in-alt"];
var unicode = 'f2f6';
var svgPathData = 'M201 95L345 239c9.4 9.4 9.4 24.6 0 33.9L201 417c-6.9 6.9-17.2 8.9-26.2 5.2S160 409.7 160 400l0-64-112 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l112 0 0-64c0-9.7 5.8-18.5 14.8-22.2S194.1 88.2 201 95zm7 217l0 30.1 86.1-86.1-86.1-86.1 0 30.1c0 13.3-10.7 24-24 24l-136 0 0 64 136 0c6.4 0 12.5 2.5 17 7s7 10.6 7 17zM344 432l72 0c26.5 0 48-21.5 48-48l0-256c0-26.5-21.5-48-48-48l-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96l-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRightToBracket = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;